import T from 'i18n-react';
import _merge from 'lodash/merge';

class Lang {
  constructor() {
    const translationData = require('../../../resources/data/dict.json');
    const linksData = require('../../../resources/data/links.json');
    const combinedData = _merge(translationData, linksData);
    T.setTexts(combinedData, { MDFlavor: 1});
  }

  getValue(key, language, params) {
    key = this.getKey(key, language);
    return T.translate(key, params);
  }

  getKey(key, language) {
    return (key + '.' + language).toLowerCase();
  }

  loadCustomDictionary(dictionary) {
    T.setTexts(dictionary, {MDFlavor: 1})
  }
}

const lang = new Lang();
export default lang;